/**
 * Screen codes for permission checking
 * These match the screen_code values in the screenmaster table
 */
export const SCREEN_CODES = {
  // Core screens
  DASHBOARD: 'DASHBOARD',
  CAMERAS: 'CAMERAS',
  CAMERAS_LIVE: 'CAM_LIVE',
  LOCATIONS: 'LOCATIONS',
  EVENTS: 'EVENTS',
  
  // Feature screens
  ACTIONS: 'ACTIONS',
  // Shared device setup follows the existing Actions permission.
  SENSORS_DEVICES: 'SENSORS_DEVICES',
  ENTRY_EXIT: 'ENTRY_EXIT',
  PERSONS: 'PERSONS',
  PARKING: 'PARKING',
  TENANTS: 'TENANTS',
  COMPANY: 'COMPANY',
  AI_SEARCH: 'AI_SEARCH',
  CONFIGURATION: 'CONFIG',
} as const;

/**
 * Map route paths to screen codes
 */
export const ROUTE_SCREEN_MAP: Record<string, string> = {
  '/dashboard': SCREEN_CODES.DASHBOARD,
  '/cameras': SCREEN_CODES.CAMERAS,
  '/live': SCREEN_CODES.CAMERAS_LIVE,
  '/locations': SCREEN_CODES.LOCATIONS,
  '/events': SCREEN_CODES.EVENTS,
  '/actions': SCREEN_CODES.ACTIONS,
  '/sensors-devices': SCREEN_CODES.SENSORS_DEVICES,
  '/entry-exit': SCREEN_CODES.ENTRY_EXIT,
  '/persons': SCREEN_CODES.PERSONS,
  '/parking': SCREEN_CODES.PARKING,
  '/tenants': SCREEN_CODES.TENANTS,
  '/company': SCREEN_CODES.COMPANY,
  '/ai-search': SCREEN_CODES.AI_SEARCH,
};
